/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EcommerceUserApiResponseVo } from './EcommerceUserApiResponseVo';
import {
    EcommerceUserApiResponseVoFromJSON,
    EcommerceUserApiResponseVoFromJSONTyped,
    EcommerceUserApiResponseVoToJSON,
    EcommerceUserApiResponseVoToJSONTyped,
} from './EcommerceUserApiResponseVo';

/**
 * 
 * @export
 * @interface ResponseListEcommerceUserApiResponseVo
 */
export interface ResponseListEcommerceUserApiResponseVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListEcommerceUserApiResponseVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListEcommerceUserApiResponseVo
     */
    message?: string;
    /**
     * 
     * @type {Array<EcommerceUserApiResponseVo>}
     * @memberof ResponseListEcommerceUserApiResponseVo
     */
    data?: Array<EcommerceUserApiResponseVo>;
}

/**
 * Check if a given object implements the ResponseListEcommerceUserApiResponseVo interface.
 */
export function instanceOfResponseListEcommerceUserApiResponseVo(value: object): value is ResponseListEcommerceUserApiResponseVo {
    return true;
}

export function ResponseListEcommerceUserApiResponseVoFromJSON(json: any): ResponseListEcommerceUserApiResponseVo {
    return ResponseListEcommerceUserApiResponseVoFromJSONTyped(json, false);
}

export function ResponseListEcommerceUserApiResponseVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListEcommerceUserApiResponseVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(EcommerceUserApiResponseVoFromJSON)),
    };
}

export function ResponseListEcommerceUserApiResponseVoToJSON(json: any): ResponseListEcommerceUserApiResponseVo {
    return ResponseListEcommerceUserApiResponseVoToJSONTyped(json, false);
}

export function ResponseListEcommerceUserApiResponseVoToJSONTyped(value?: ResponseListEcommerceUserApiResponseVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(EcommerceUserApiResponseVoToJSON)),
    };
}

